import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";
import { Solar, Battery, Saving, Mobile } from "../../../resources/images/calculator/svgImages";
import { Utils } from "../../../resources/util";

export default function ExtraBenefits(props) {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
      <Grid item xs={12} className={`${classes.section} ${classes.endCalc}`}>
        <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
          <Grid className={`${classes.section1}`} item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              Instead of paying ${Utils.formatCurrency(props.annualBill)} per year for dirty energy that keeps going up you could be paying a fixed $
              {Utils.formatCurrency(props.bundleAmount)} per month – and helping to save the planet!
            </Typography>
          </Grid>
          <Grid className={`${classes.section2} ${classes.sections}`} item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              Plus, you get all this cool stuff included
            </Typography>
          </Grid>
          <Grid className={`${classes.section3} ${classes.sections}`} item xs={12}>
            <Grid container direction="row" justifyContent="center" alignItems="center">
              <Grid item xs={3}>
                <div className={classes.imageWrapper}>
                  <Solar cardImage={`${classes.cardImage}`} />
                </div>
                <Typography>Solar</Typography>
              </Grid>
              <Grid item xs={3}>
                <div className={classes.imageWrapper}>
                  <Battery cardImage={`${classes.cardImage}`} />
                </div>
                <Typography>Batteries</Typography>
              </Grid>
              <Grid item xs={3}>
                <div className={classes.imageWrapper}>
                  <Saving />
                </div>
                <Typography>Wholesale power price</Typography>
              </Grid>
              <Grid item xs={3}>
                <div className={classes.imageWrapper}>
                  <Mobile />
                </div>
                <Typography>Mobile app</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={`${classes.section4} ${classes.sections}`} item xs={12}>
            <Button variant="contained" size="large" color="primary" className={classes.moreButton}>
              Tell me more
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

ExtraBenefits.propTypes = {
  annualBill: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  bundleAmount: PropTypes.oneOfType([PropTypes.string || PropTypes.number])
};
